import { useEffect, useState } from "react";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { CommunicationSupportData } from "../../../../../components/tables/communication-support-tables/communicationSupport";
import { getAllSupports } from "../../../../../API/Mediatheque/Support/supportService";

const breadcrumbItems = [
  {
    title: "Support de communications",
    link: "/admin-dashboard/mediatheque/support-de-communications",
  },
];
export default function CommunicationSupport() {
  const [supports, setSupports] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllSupports();
    setSupports(response?.supports);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <CommunicationSupportData data={supports} />
        </div>
      </div>
    </>
  );
}
